import styled, { css } from 'styled-components';

import responsive from 'theme/responsive';

import SearchDetailsBar from './SearchDetailsBar';

const StyledDetailsBar = styled(SearchDetailsBar)`
    .inner {
        padding: 10px 20px;

        ${responsive.md(css`
            padding: 0;
        `)}
    }

    &.no-search {
        .inner {
            padding-top: 20px;
        }
    }

    .search-details {
        min-height: 64px;
        display: flex;
        align-items: center;
        font-size: 14px;
        justify-content: space-between;
    }

    .change-search-trigger {
        margin-left: 10px;
        font-weight: 700;
        cursor: pointer;
        min-width: 110px;
        display: block;
        text-align: right;
    }

    .search-box-container {
        display: none;
        justify-content: center;
        padding-top: 20px;

        ${responsive.md(css`
            padding-top: 0;
        `)}

        &--open {
            display: flex;
        }
    }
`;

export default StyledDetailsBar;
